import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import { getDummyMenuItems } from '../data/dummyMenus';

export const useMenuItems = (restaurantId) => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMenuItems = React.useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${API_ENDPOINTS.CUSTOMER_MENU}?restaurantId=${restaurantId}`);
      setMenuItems(response.data);
    } catch (err) {
      const fallback = getDummyMenuItems(restaurantId);
      if (fallback.length > 0) {
        setMenuItems(fallback);
        setError(null);
      } else {
        setError("Failed to load menu items");
      }
      console.error("Failed to load menu items:", err);
    } finally {
      setLoading(false);
    }
  }, [restaurantId]);

  useEffect(() => {
    if (restaurantId) {
      fetchMenuItems();
    }
  }, [restaurantId, fetchMenuItems]);

  const filteredMenuItems = useMemo(() => ({
    todaysSpecials: menuItems.filter(item => item.itemCategory === 'todaysSpecial'),
    quicklyServed: menuItems.filter(item => item.quickServe),
    getFilteredItems: (categoryFilter, typeFilter) => 
      menuItems.filter(item => {
        const categoryMatch = categoryFilter === "all" || 
          item.itemCategory.toLowerCase() === categoryFilter.toLowerCase();
        const typeMatch = typeFilter === "all" || 
          item.itemType.toLowerCase() === typeFilter.toLowerCase();
        return categoryMatch && typeMatch;
      })
  }), [menuItems]);

  return {
    menuItems,
    loading,
    error,
    refetch: fetchMenuItems,
    ...filteredMenuItems
  };
};